import gql from "graphql-tag";

export const GET_USER_PROFILE_TYPE = gql`
  query getUserProfileType($mobileNumber: String!) {
    getUserProfileType(mobileNumber: $mobileNumber) {
      profile
    }
  }
`;

export const GET_PATIENT_BY_MOBILE_NUMBER = gql`
  query GetPatientByMobileNumber($mobileNumber: String) {
    getPatientByMobileNumber(mobileNumber: $mobileNumber) {
      patients {
        id
        externalAuthId
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        dateOfBirth
        emailAddress
        photoUrl
        referralCode
        partnerId
        createdDate
        patientMedicalHistory {
          height
          weight
          bp
          dietAllergies
          bloodGroup
        }
      }
    }
  }
`;

export const GET_CURRENT_PATIENTS = gql`
  query GetCurrentPatients {
    getCurrentPatients {
      patients {
        id
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        dateOfBirth
        emailAddress
        photoUrl
        createdDate
      }
    }
  }
`;
